import React, { useState, useContext } from 'react'
import styled, { css } from 'styled-components'
import classNames from 'classnames'
import breakpoints from '../../styles/breakpoints'
import { IconType } from '../system/icons'
import Filters, { FiltersContext } from './filters'
import IconButton from '../system/forms/icon-button'
import ClearFiltersButton from './clear-filters-button'

const StyledFilters = styled.div`
  display: none;

  &.expanded {
    display: grid;
    grid-gap: ${props => props.theme.spacing.base400};
    padding-bottom: ${props => props.theme.spacing.base600};
    transition: margin-top 300ms ease;
  }
`

const MobileFilters = styled.div`
  display: grid;
  row-gap: ${props => props.theme.spacing.base500};

  ${({ hasFilters }: { hasFilters: boolean }) =>
    hasFilters &&
    css`
      grid-template-columns: auto 1fr;

      ${StyledFilters} {
        grid-column: 1 / span 2;
      }
    `}

  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`

const ToggleButton = styled(IconButton)`
  justify-self: end;
`

const ToggleableFilters = (): JSX.Element => {
  const [showFilters, setShowFilters] = useState(false)
  const { hasFilters } = useContext(FiltersContext)

  return (
    <MobileFilters hasFilters={hasFilters}>
      <ClearFiltersButton />
      <ToggleButton
        icon={showFilters ? IconType.ExpandUp : IconType.FilterReverse}
        onClick={() => setShowFilters(!showFilters)}
      />

      <StyledFilters className={classNames({ expanded: showFilters })}>
        <Filters variant="outlined" isMobile={true} />
      </StyledFilters>
    </MobileFilters>
  )
}

export default ToggleableFilters
